import { defineMessages } from "react-intl";

export const internalizedDays = defineMessages({
  Sunday: { defaultMessage: "Sunday" },
  Monday: { defaultMessage: "Monday" },
  Tuesday: { defaultMessage: "Tuesday" },
  Wednesday: { defaultMessage: "Wednesday" },
  Thursday: { defaultMessage: "Thursday" },
  Friday: { defaultMessage: "Friday" },
  Saturday: { defaultMessage: "Saturday" },
});
